import { render, staticRenderFns } from "./Bookmarks.htm?vue&type=template&id=f274c694&scoped=true&"
import script from "./Bookmarks.ts?vue&type=script&lang=js&"
export * from "./Bookmarks.ts?vue&type=script&lang=js&"
import style0 from "./Bookmarks.scss?vue&type=style&index=0&id=f274c694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f274c694",
  null
  
)

export default component.exports